module.exports = __webpack_public_path__ + "static/media/watercolor.56789b6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/watercolor.jpg
// module id = 173
// module chunks = 0